import { createApi } from './api-core';
import { getInitData } from './tma';

export { ApiError } from './api-core';
export type { Api, BroadcastResult, EvalEstimate, PromptStep, PromptSteps } from './api-core';

export const api = createApi({
  baseUrl: import.meta.env.VITE_API_URL ?? '/api',
  getInitData,
});
